module.exports = __webpack_public_path__ + "media/old_images/default-image-resting-cabin-orange-2514f3dd.png";